export default __webpack_public_path__ + "static/media/Savant's Gloves of the Burning Disc.265d37b7.jpg";